// 因为数据从 car.js 中获取，所以需要引入该文件
// import store from './modules/store'
const getters = {
	
}
// 并导出
export default getters;